import { InvoiceLineCoreBase } from "./invoice-line.core.base"


export class InvoiceLineCore extends InvoiceLineCoreBase {

}